export default __webpack_public_path__ + "static/media/placeholder_dummy2016-streetfashion01-mobile-de.16c4839c.png";